module.exports = "https://health.dajiuxing.com.cn/img/assets/sharing/headbackground.png"


//////////////////
// WEBPACK FOOTER
// ./build/cdn-img-stub.js?path=assets%2Fsharing%2Fheadbackground.png
// module id = yTGP
// module chunks = 93